import { acquireLock } from 'Api/document';
import { useMutation, useQueryClient } from 'react-query';

export const useAcquireLockDocument = (setEnableVerify, setEnableRenderInput) => {
  const queryClient = useQueryClient();

  const { mutate: acquireLockDocument, isLoading } = useMutation(acquireLock, {
    onSuccess: data => {
      if (data === undefined) {
        // Lock request returned no body — the API call likely failed silently
        // (execute() swallows non-401 errors and resolves to undefined).
        // Leave enableRenderInput false; the re-fetch will sort out real state.
        setEnableVerify(false);
      } else {
        // Lock successfully acquired: show the verification form immediately
        // rather than waiting for the invalidateQueries re-fetch to resolve.
        setEnableVerify(true);
        setEnableRenderInput(true);
      }

      queryClient.invalidateQueries('GetFileReview');
      queryClient.invalidateQueries('ListFiles');
    },
  });

  return { acquireLockDocument, isLoading };
};
